export const LS_AI_IMAGE_GENERATION_STATUSES = 'ai_image_generation_statuses';
